import { atomWithStorage, createJSONStorage } from 'jotai/utils'

/** 時モードのズームレベル（1枠あたりの時間数） */
export const ZOOM_LEVELS = [0.5, 1, 2] as const
export type HoursPerTick = (typeof ZOOM_LEVELS)[number]

const HOURS_PER_TICK_STORAGE_KEY = 'vdb:hoursPerTick'
const DEFAULT_HOURS_PER_TICK: HoursPerTick = 1

/** localStorage から読み込んだ値が ZOOM_LEVELS に含まれない場合はデフォルトにフォールバック */
const storage = createJSONStorage<HoursPerTick>(() => localStorage)
const originalGetItem = storage.getItem.bind(storage)
storage.getItem = (key, initialValue) => {
  const value = originalGetItem(key, initialValue)
  if (!ZOOM_LEVELS.includes(value as HoursPerTick))
    return DEFAULT_HOURS_PER_TICK
  return value
}

export const hoursPerTickAtom = atomWithStorage<HoursPerTick>(
  HOURS_PER_TICK_STORAGE_KEY,
  DEFAULT_HOURS_PER_TICK,
  storage,
  { getOnInit: true }
)
hoursPerTickAtom.debugLabel = 'hoursPerTickAtom'
